export const NO_STATE_OPTION = { name: 'No state', code: 'NO_STATE' };
